/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ScopeFilterRegion {
    getFixupPrototypeFunction() { return ScopeFilterRegion.fixupPrototype; }

    static newInstance(model: Partial<ScopeFilterRegion>): ScopeFilterRegion {
        let obj = Object.assign(new ScopeFilterRegion(), model);
        ScopeFilterRegion.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ScopeFilterRegion>): ScopeFilterRegion {
        if (!model) return null;
        return ScopeFilterRegion.newInstance(<ScopeFilterRegion> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ScopeFilterRegion) {
        if (!obj) return;

        models.ScopeFilterRegion.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ScopeFilterRegion): boolean {
        Object.setPrototypeOf(obj, ScopeFilterRegion.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Type for region
     */
    type: string;

    /**
     * Key for region
     */
    key: string;

    /**
     * Name for region
     */
    name: string;

    /**
     * Id for region
     */
    id: string;

}
